var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMsgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_66_573)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 10.9069C0 11.2878 0.4315 11.5093 0.740969 11.2885L3.31819 9.45003C3.53434 9.29584 3.78897 9.21434 4.05453 9.21434H9.72272C10.7205 9.21434 11.5322 8.40262 11.5322 7.40491V1.45706C11.5322 1.19819 11.3223 0.988312 11.0634 0.988312H1.80944C0.811719 0.988312 0 1.8 0 2.79775L0 10.9069ZM0.9375 2.79775C0.9375 2.31694 1.32866 1.92581 1.80944 1.92581H10.5946V7.40491C10.5946 7.88572 10.2035 8.27684 9.72269 8.27684H4.0545C3.59263 8.27684 3.14975 8.41862 2.77375 8.68684L0.9375 9.99675V2.79775Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 6.43362C16 5.43574 15.1883 4.62393 14.1906 4.62393H12.9384C12.6795 4.62393 12.4696 4.83381 12.4696 5.09268C12.4696 5.35156 12.6795 5.56143 12.9384 5.56143H14.1906C14.6714 5.56143 15.0625 5.95271 15.0625 6.43362V13.6325L13.2262 12.3227C12.8503 12.0544 12.4074 11.9127 11.9456 11.9127H6.27715C5.79637 11.9127 5.40527 11.5214 5.40527 11.0405V10.6205C5.40527 10.3617 5.1954 10.1518 4.93652 10.1518C4.67765 10.1518 4.46777 10.3617 4.46777 10.6205V11.0405C4.46777 12.0384 5.27946 12.8502 6.27715 12.8502H11.9456C12.2111 12.8502 12.4657 12.9317 12.6818 13.0858L15.259 14.9243C15.5669 15.144 16 14.9247 16 14.5427L16 6.43362Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.37073 4.47934H8.78648C9.04535 4.47934 9.25523 4.26946 9.25523 4.01059C9.25523 3.75171 9.04535 3.54184 8.78648 3.54184H3.37073C3.11185 3.54184 2.90198 3.75171 2.90198 4.01059C2.90198 4.26946 3.11185 4.47934 3.37073 4.47934Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.37073 6.66684H8.78648C9.04535 6.66684 9.25523 6.45696 9.25523 6.19809C9.25523 5.93921 9.04535 5.72934 8.78648 5.72934H3.37073C3.11185 5.72934 2.90198 5.93921 2.90198 6.19809C2.90198 6.45696 3.11185 6.66684 3.37073 6.66684Z",
    fill: "#515151"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_66_573"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMsgIcon);
export default __webpack_public_path__ + "static/media/msgIcon.75063e8022d20a92df90750d74fd7d6b.svg";
export { ForwardRef as ReactComponent };